function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}

function buildLayoutFromRows(rows, containerWidth, spacing) {
    let top = 0;
    const items = [];
    rows.forEach((row) => {
        const ratioSum = row.reduce((sum, item) => sum + item.ratio, 0);
        const rowHeight = ratioSum > 0
            ? Math.round((containerWidth - spacing * (row.length - 1)) / ratioSum)
            : Math.round(containerWidth / Math.max(row.length, 1));
        let left = 0;
        row.forEach((item, index) => {
            const rawWidth = Math.round(rowHeight * item.ratio);
            const width = index === row.length - 1 ? containerWidth - left : rawWidth;
            items[item.index] = {
                top,
                left,
                width,
                height: rowHeight
            };
            left += width + spacing;
        });
        top += rowHeight + spacing;
    });
    return {
        width: containerWidth,
        height: Math.max(top - spacing, 0),
        items
    };
}

function buildRowLayout(mediaSizes, containerWidth, spacing) {
    const rows = [];
    let currentRow = [];
    let currentRatio = 0;
    mediaSizes.forEach((size) => {
        const ratio = clamp(size.width / size.height, 0.6, 1.8);
        currentRow.push({
            index: size.index,
            ratio
        });
        currentRatio += ratio;
        if (currentRow.length >= 3 || currentRatio >= 3.2) {
            rows.push(currentRow);
            currentRow = [];
            currentRatio = 0;
        }
    });
    if (currentRow.length) {
        rows.push(currentRow);
    }
    return buildLayoutFromRows(rows, containerWidth, spacing);
}

function calculateAlbumLayout(mediaSizes = [], containerWidth, spacing = 2) {
    if (!mediaSizes.length) {
        return {
            width: containerWidth,
            height: 0,
            items: []
        };
    }
    if (mediaSizes.length === 1) {
        return buildLayoutFromRows([[
            {
                index: mediaSizes[0].index,
                ratio: clamp(mediaSizes[0].width / mediaSizes[0].height, 0.6, 1.8)
            }
        ]], containerWidth, spacing);
    }
    if (mediaSizes.length === 2) {
        const a = clamp(mediaSizes[0].width / mediaSizes[0].height, 0.6, 1.8);
        const b = clamp(mediaSizes[1].width / mediaSizes[1].height, 0.6, 1.8);
        if (a > 1.4 && b > 1.4) {
            return buildLayoutFromRows([
                [{ index: mediaSizes[0].index, ratio: a }],
                [{ index: mediaSizes[1].index, ratio: b }]
            ], containerWidth, spacing);
        }
        return buildLayoutFromRows([[
            { index: mediaSizes[0].index, ratio: a },
            { index: mediaSizes[1].index, ratio: b }
        ]], containerWidth, spacing);
    }
    if (mediaSizes.length === 3) {
        const ratios = mediaSizes.map((item) => clamp(item.width / item.height, 0.6, 1.8));
        if (ratios[0] > 1.35) {
            return buildLayoutFromRows([
                [{ index: mediaSizes[0].index, ratio: ratios[0] }],
                [
                    { index: mediaSizes[1].index, ratio: ratios[1] },
                    { index: mediaSizes[2].index, ratio: ratios[2] }
                ]
            ], containerWidth, spacing);
        }
    }
    if (mediaSizes.length === 4) {
        return buildLayoutFromRows([
            [
                { index: mediaSizes[0].index, ratio: clamp(mediaSizes[0].width / mediaSizes[0].height, 0.6, 1.8) },
                { index: mediaSizes[1].index, ratio: clamp(mediaSizes[1].width / mediaSizes[1].height, 0.6, 1.8) }
            ],
            [
                { index: mediaSizes[2].index, ratio: clamp(mediaSizes[2].width / mediaSizes[2].height, 0.6, 1.8) },
                { index: mediaSizes[3].index, ratio: clamp(mediaSizes[3].width / mediaSizes[3].height, 0.6, 1.8) }
            ]
        ], containerWidth, spacing);
    }
    return buildRowLayout(mediaSizes, containerWidth, spacing);
}

function buildPlaceholderLayout(itemCount, containerWidth, spacing = 2) {
    const columnCount = itemCount <= 2 ? itemCount : Math.min(3, itemCount);
    const itemWidth = Math.floor((containerWidth - spacing * (columnCount - 1)) / columnCount);
    const rows = Math.ceil(itemCount / columnCount);
    const items = [];
    for (let index = 0; index < itemCount; index++) {
        const row = Math.floor(index / columnCount);
        const col = index % columnCount;
        items.push({
            top: row * (itemWidth + spacing),
            left: col * (itemWidth + spacing),
            width: itemWidth,
            height: itemWidth
        });
    }
    return {
        width: containerWidth,
        height: rows * itemWidth + Math.max(0, rows - 1) * spacing,
        items
    };
}

export {
    calculateAlbumLayout,
    buildPlaceholderLayout
};
